var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counter",class:{ 'is-negative': _vm.remainingChars < 0 }},[_c('span',[_vm._v(_vm._s(_vm.remainingChars))]),(_vm.showLabel)?_c('span',[_vm._v(_vm._s(_vm.remainingCharsCopy))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }